import { LineReveal, Reveal } from "./Motion";
import { CountUp } from "./CountUp";
import { experience, education, stats, earlierCareer } from "../data/projects";

const Row = ({ a, b, c, d, m, testid }) => (
  <Reveal>
    <div className="row-hover grid grid-cols-12 gap-3 border-t border-line py-6 md:py-8" data-testid={testid}>
      <p className="col-span-12 font-mono text-[11px] uppercase tracking-[0.18em] text-muted md:col-span-3">{c}</p>
      <h3 className="col-span-12 font-display text-2xl font-semibold tracking-[-0.035em] text-ink md:col-span-4 md:text-3xl">{a}</h3>
      <div className="col-span-12 md:col-span-5">
        <p className="text-base text-ink">{b}</p>
        {m && <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.14em] text-muted">{m}</p>}
        {d && (
          <ul className="mt-3 space-y-2">
            {d.map((x) => (
              <li key={x} className="flex gap-3 text-sm leading-relaxed text-muted">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-accent" />
                {x}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  </Reveal>
);

const Stats = () => (
  <div className="mb-14 grid gap-8 md:mb-20 md:grid-cols-3" data-testid="experience-stats">
    {stats.map((s, i) => (
      <Reveal key={s.unit} delay={i * 0.1}>
        <div className="border-l-2 border-accent pl-5">
          <p className="font-display text-6xl font-semibold leading-none tracking-[-0.06em] text-ink md:text-7xl">
            <CountUp value={s.value} /><span className="ml-2 font-serif text-2xl font-normal italic tracking-normal text-ink md:text-3xl">{s.unit}</span>
          </p>
          <p className="mt-3 max-w-[16rem] text-sm text-muted">{s.label}</p>
        </div>
      </Reveal>
    ))}
  </div>
);

const Earlier = () => (
  <Reveal>
    <div className="grid grid-cols-12 gap-3 border-t border-line py-6 md:py-8" data-testid="experience-earlier-career">
      <p className="col-span-12 font-mono text-[11px] uppercase tracking-[0.18em] text-muted md:col-span-3">2009 — 2022</p>
      <h3 className="col-span-12 font-display text-2xl font-semibold tracking-[-0.035em] text-ink md:col-span-4 md:text-3xl">Earlier career</h3>
      <ul className="col-span-12 divide-y divide-line md:col-span-5">
        {earlierCareer.map((e) => (
          <li key={e.org} className="flex flex-wrap items-baseline justify-between gap-x-4 py-2 first:pt-0">
            <span className="text-base text-ink">{e.role} <span className="text-muted">· {e.org}</span></span>
            <span className="font-mono text-[11px] tracking-[0.12em] text-muted">{e.period}</span>
          </li>
        ))}
      </ul>
    </div>
  </Reveal>
);

const Block = ({ id, label, title, children, intro }) => (
  <section id={id} className="px-5 py-20 md:px-10 md:py-32" data-testid={`${id}-section`}>
    <div className="mb-12 grid gap-6 md:mb-16 md:grid-cols-12">
      <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted md:col-span-3">{label}</p>
      <LineReveal as="h2" inView lines={title} className="font-display text-5xl font-semibold leading-[0.95] tracking-[-0.05em] text-ink md:col-span-9 md:text-7xl" />
    </div>
    {intro}
    <div className="border-b border-line">{children}</div>
  </section>
);

export const Experience = () => (
  <Block id="experience" label="(01) Experience" intro={<Stats />} title={["Where the", <em key="e" className="font-serif font-normal italic text-ink">work happens.</em>]}>
    {experience.map((e, i) => <Row key={i} a={e.role} b={e.org} c={e.period} d={e.points} m={e.meta} testid={`experience-row-${i}`} />)}
    <Earlier />
  </Block>
);

export const Education = () => (
  <Block id="education" label="(02) Education" title={["Where it", <em key="e" className="font-serif font-normal italic text-ink">started.</em>]}>
    {education.map((e, i) => <Row key={i} a={e.course} b={e.place} c={e.period} testid={`education-row-${i}`} />)}
  </Block>
);
